import type { IHelpdeskTicketContext } from "@kuika/kuika-cl-model";
import { HELPDESK_CONTEXT_ID_MAX_LENGTH, HELPDESK_CONTEXT_NAME_MAX_LENGTH } from "./helpdesk-config";

interface IHelpdeskScreenRef {
  id: string;
  name?: string;
}

interface IHelpdeskProjectRef {
  id?: string;
  name?: string;
}

/** The parts of the designer state a ticket's context is read from. */
export interface IHelpdeskContextSource {
  project?: IHelpdeskProjectRef | null;
  sdId?: string | null;
  screenList?: IHelpdeskScreenRef[] | null;
}

/**
 * The app and screen the user is on. Management pages have no project or screen, so both may be
 * empty; the workspace and environment are added by the server from the verified session.
 */
export function buildHelpdeskTicketContext(source: IHelpdeskContextSource | null | undefined): IHelpdeskTicketContext {
  const project: IHelpdeskProjectRef | null | undefined = source?.project;
  const screenId: string | null | undefined = source?.sdId;
  const screen: IHelpdeskScreenRef | undefined = screenId
    ? source?.screenList?.find((item: IHelpdeskScreenRef): boolean => item.id === screenId)
    : undefined;

  return {
    appName: clip(project?.name, HELPDESK_CONTEXT_NAME_MAX_LENGTH),
    appId: clip(project?.id, HELPDESK_CONTEXT_ID_MAX_LENGTH),
    screenName: clip(screen?.name, HELPDESK_CONTEXT_NAME_MAX_LENGTH),
    screenId: screen ? clip(screenId, HELPDESK_CONTEXT_ID_MAX_LENGTH) : null
  };
}

/** The ITSM refuses longer context values; the server clips the same way. */
function clip(value: string | null | undefined, maxLength: number): string | null {
  const trimmed: string = (value ?? "").trim();
  if (!trimmed) return null;
  return trimmed.length <= maxLength ? trimmed : trimmed.slice(0, maxLength);
}
